// extracted by mini-css-extract-plugin
module.exports = {"disclaimerBannerText":"DisclaimerBanner_disclaimerBannerText__1uJxh"};